import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import SuggestText, { suggestTextPropTypes } from './SuggestText';
import { isNotEmptyArray } from '../../common/utils/helpers';
import HoverIcon, { HOVER_ICON_OPTIONS } from '../../../HoverIcon';

// DEPRECATED

const SEARCH_SUGGESTIONS_CONSTS = {
  BUTTON_TYPE: 'button',
  HOVER_ICON_TRANSITION: HOVER_ICON_OPTIONS.TRANSITIONS.SHARP,
};

const StyledButton = styled.button`
  cursor: pointer;
  display: block;
  font-size: ${props => props.theme.fontSize.lg};
  overflow: hidden;
  max-width: 90%;
  padding: ${props => `${props.theme.padding.xsmall} 0`};
  text-align: left;
  text-overflow: ellipsis;
  transition: ${props =>
    props.theme.transition.create(['color'], {
      duration: props.theme.transition.duration.shortest,
      timingFunction: props.theme.transition.timingFunction.sharp,
    })};
  /* width: 100%; */
  white-space: nowrap;
  &:hover {
    color: ${props => props.theme.palette.primary};
  }

  /** EMPHASIS */
  ${props =>
    props.emphasis
      ? css`
          color: ${props.theme.text.text500};
        `
      : css`
          color: ${props.theme.text.text300};
        `}
`;

const StyledHeading = styled.p`
  font-size: ${props => props.theme.fontSize.lg};
  font-weight: 600;
  margin-top: ${props => props.theme.margin.normal};
  margin-bottom: ${props => props.theme.margin.small};

  /** EMPHASIS */
  ${props =>
    props.emphasis
      ? css`
          color: ${props.theme.text.text500};
        `
      : css`
          color: ${props.theme.text.text300};
        `}
`;

const Suggestion = ({
  emphasis,
  fieldId,
  handleSuggestionClick,
  highlightMatch,
  suggestion,
  heading,
}) => {
  const handleSuggestionClickInternal = () => {
    handleSuggestionClick(suggestion);
  };

  return (
    <StyledButton
      emphasis={emphasis}
      onClick={handleSuggestionClickInternal}
      type={SEARCH_SUGGESTIONS_CONSTS.BUTTON_TYPE}
    >
      <SuggestText
        fieldId={fieldId}
        highlightMatch={highlightMatch}
        suggestLabel={suggestion.suggestLabel}
      />
    </StyledButton>
  );
};

const SearchSuggestions = ({
  emphasis,
  fieldId,
  handleSuggestionClick,
  heading,
  Helper,
  highlightMatch,
  hoverIcon,
  suggestions,
}) => {
  if (!isNotEmptyArray(suggestions)) {
    return <>{Helper && <Helper />}</>;
  }

  return (
    <>
      {heading && <StyledHeading emphasis={emphasis}>{heading}</StyledHeading>}
      {suggestions.map(suggestion =>
        hoverIcon ? (
          <HoverIcon
            key={suggestion.id}
            transition={SEARCH_SUGGESTIONS_CONSTS.HOVER_ICON_TRANSITION}
          >
            <Suggestion
              emphasis={emphasis}
              fieldId={fieldId}
              handleSuggestionClick={handleSuggestionClick}
              highlightMatch={highlightMatch}
              suggestion={suggestion}
              heading={heading}
            />
          </HoverIcon>
        ) : (
          <Suggestion
            key={suggestion.id}
            emphasis={emphasis}
            fieldId={fieldId}
            handleSuggestionClick={handleSuggestionClick}
            highlightMatch={highlightMatch}
            suggestion={suggestion}
            heading={heading}
          />
        )
      )}
    </>
  );
};

const searchSuggestionsPropTypes = {
  emphasis: PropTypes.bool,
  fieldId: suggestTextPropTypes.fieldId,
  handleSuggestionClick: PropTypes.func,
  heading: PropTypes.string,
  Helper: PropTypes.elementType,
  highlightMatch: suggestTextPropTypes.highlightMatch,
  hoverIcon: PropTypes.bool,
  suggestions: PropTypes.arrayOf(PropTypes.object),
};

const searchSuggestionDefaultProps = {
  emphasis: false,
  fieldId: undefined,
  handleSuggestionClick: undefined,
  heading: undefined,
  Helper: undefined,
  highlightMatch: false,
  hoverIcon: false,
  suggestions: undefined,
};

SearchSuggestions.propTypes = searchSuggestionsPropTypes;
SearchSuggestions.defaultProps = searchSuggestionDefaultProps;
export default SearchSuggestions;
export { searchSuggestionDefaultProps, searchSuggestionsPropTypes };
